import { BaseApiBlob } from "../services/BaseApi";
import { InterceptToken } from "../interceptors/TokenInterceptor";

let downloadQueue = [];
let isProcessingQueue = false;
let activeDownloadIds = new Set();
let downloadPromises = new Map();

const getDownloadId = (request) => {
  const paramsString = JSON.stringify(request?.parameters || {});
  return `${request?.name}_${btoa(paramsString).replace(/[+/=]/g, '')}`;
};

const processDownload = async (request, resolve, reject, voucherUrl) => {
  if (!request) {
    if (reject) {
      reject(new Error("Request inválido"));
    }
    return;
  }

  const downloadId = getDownloadId(request);
  
  if (activeDownloadIds.has(downloadId)) {
    const existingPromise = downloadPromises.get(downloadId);
    if (existingPromise && resolve) {
      existingPromise.then(resolve).catch(reject);
    } else if (resolve) {
      resolve();
    }
    return;
  }

  activeDownloadIds.add(downloadId);

  try {
    const response = await InterceptToken(BaseApiBlob.post, voucherUrl, request);
    
    if (!response || !response.data) {
      throw new Error("Respuesta inválida del servidor");
    }
    
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${request?.name || "voucher"}.pdf`;
    a.style.display = "none";
    
    const allLinks = document.querySelectorAll('a[data-download-id]');
    allLinks.forEach((link) => {
      if (link.getAttribute('data-download-id') === downloadId && document.body.contains(link)) {
        document.body.removeChild(link);
      }
    });
    
    a.setAttribute("data-download-id", downloadId);
    document.body.appendChild(a);
    
    setTimeout(() => {
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        if (document.body.contains(a)) {
          document.body.removeChild(a);
        }
        activeDownloadIds.delete(downloadId);
        downloadPromises.delete(downloadId);
        if (resolve) {
          resolve();
        }
      }, 300);
    }, 100);
  } catch (error) {
    activeDownloadIds.delete(downloadId);
    downloadPromises.delete(downloadId);
    console.error("Error al descargar voucher:", error);
    if (reject) {
      reject(error);
    }
  }
};

const processQueue = async (voucherUrl) => {
  if (isProcessingQueue) {
    return;
  }

  if (downloadQueue.length === 0) {
    return;
  }

  isProcessingQueue = true;

  try {
    while (downloadQueue.length > 0) {
      const queueItem = downloadQueue.shift();
      if (queueItem && queueItem.request) {
        await processDownload(queueItem.request, queueItem.resolve, queueItem.reject, voucherUrl);
      }
    }
  } catch (error) {
    console.error("Error en processQueue:", error);
  } finally {
    isProcessingQueue = false;
    
    if (downloadQueue.length > 0) {
      processQueue(voucherUrl);
    }
  }
};

export const createVoucherDownloader = (voucherUrl) => {
  return (request) => {
    if (!request) {
      return Promise.resolve();
    }

    const downloadId = getDownloadId(request);
    
    if (downloadPromises.has(downloadId)) {
      return downloadPromises.get(downloadId);
    }

    let resolvePromise;
    let rejectPromise;
    
    const promise = new Promise((resolve, reject) => {
      resolvePromise = resolve;
      rejectPromise = reject;
    });
    
    downloadPromises.set(downloadId, promise);
    
    downloadQueue.push({
      request,
      resolve: resolvePromise,
      reject: rejectPromise
    });
    
    processQueue(voucherUrl);

    return promise;
  };
};

